import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import { useRelations, generateUrls } from '@hooks/useBrandGroup'
import useBrandGroupPublication from '@hooks/useBrandGroupPublication'

import type { BrandGroupPublicationModel } from '@models/types'

interface BrandGroupListItemProps {
  brandGroupPublication: BrandGroupPublicationModel,
}

const BrandGroupListItem = (props:BrandGroupListItemProps) => {
  const { brandGroupPublication } = props

  const brandGroupPublicationPayload = useBrandGroupPublication(brandGroupPublication)

  const {
    brandGroup,
    brandGroup: { title },
    callbacks: { deleteBrandGroupPublication },
  } = brandGroupPublicationPayload

  const { brand: { title: brandTitle } } = useRelations(brandGroup)

  const { editBrandGroupUrl } = generateUrls(brandGroup)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn: deleteBrandGroupPublication,
    },
    strings: {
      deleteString: 'remove',
      entityName: 'Brand Group',
    },
  }

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {brandTitle}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          marginRight="medium"
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editBrandGroupUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandGroupListItem
